<template>
  <div class="progress-bar-container">
    <div class="progress-bar">
      <div class="progress-fill" :style="fillProgressBarAnimation" ref="progressBarAnimation"></div>
    </div>
    <div class="percentage-display">{{ currentPercentage }}%</div>
  </div>
</template>
<script>
export default {
  name: 'progress-bar',
  computed: {
    fillProgressBarAnimation() {
      return {
        'animation-duration': `${this.duration}s`,
      };
    },
  },
  props: {
    duration: {
      type: Number,
      required: true,
    },
    enabled: {
      type: Boolean,
      required: true,
    },
    complete: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      currentPercentage: 0,
    };
  },
  watch: {
    complete(newValue) {
      if (newValue) {
        this.currentPercentage = 100;
      }
    },
  },
  mounted() {
    const that = this;
    const interval = setInterval(() => {
      if (that.currentPercentage < 99) {
        that.currentPercentage += 1;
      } else {
        that.currentPercentage = 99;
        clearInterval(interval);
      }
    }, (this.duration * 1000) / 100);
  },
};
</script>
<style lang="scss" scoped>
.progress-bar-container {
  width: 60%;
  margin: 0 auto;
  .progress-bar {
    width: 100%;
    height: 10px;
    border: 1px solid rgba(255, 255, 255, 0.25);
    border-radius: 10px;
    background-color: #ddd;
    .progress-fill {
      height: 10px;
      border-radius: 10px;
      background-color: #0077cf;
      animation-name: fill;
      animation-timing-function: ease-in-out;
      animation-direction: normal;
      animation-iteration-count: 1;
      animation-fill-mode: none;
      animation-play-state: running;
    }
  }
  .percentage-display {
    @include mds-body-text-m();
    text-align: right;
  }
}
@keyframes fill {
  0% {
    width: 0;
  }
  100% {
    width: 100%;
  }
}
</style>
